import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import router from './router'
import store from './store'






import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false;


import VueFlashMessage from 'vue-flash-message';
Vue.use(VueFlashMessage, {
    messageOptions: {
        timeout: 3000,
        pauseOnInteract: true
    }
});
require('vue-flash-message/dist/vue-flash-message.min.css');

import axios from 'axios'

var axiosConfig = {
    baseURL: process.env.VUE_APP_API_BASE_URL,
};

Vue.prototype.$axios = axios.create(axiosConfig);


import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
// Vuetify's CSS styles
import 'vuetify/dist/vuetify.min.css'

import cs from 'vuetify/es5/locale/cs'


Vue.use(Vuetify, {
    lang: {
        locales: { cs},
        current: 'cs'
    }
})

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)


import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(TiptapVuetifyPlugin, {
    // the next line is important! You need to provide the Vuetify Object to this place.
    vuetify: new Vuetify(), // same as "vuetify: vuetify"
    // optional, default to 'md' (default vuetify icons before v2.0.0)
    iconsGroup: 'md',
    lang: {
        locales: { cs },
        current: 'cs'
    }

})

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyB4Q1IwveH0iKxH95Ru6HELob--Oi7mmrU',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },
    region: 'CZ',
    language: 'cs',

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then set installComponents to 'false'.
    //// If you want to automatically install all the components this property must be set to 'true':
    installComponents: true
});


new Vue({
    vuetify: new Vuetify(),
    router: router,
    store: store,

    created: function() {
        if(
            [
                'Login'

            ].includes(router.history.current.name)
        ){
            console.log('public')
        } else {

            const token = localStorage.getItem('token');

            if(!token){
                router.push({name: 'Login'});
            }else{
                store.dispatch('getUserProfile');
            }

        }


    },

  render: h => h(App),
}).$mount('#app');



router.beforeEach((to, from, next) => {
    if(
        [
            'Login'

        ].includes(to.name)
    ){
        console.log('public')
    } else {

        const token = localStorage.getItem('token');

        if(!token){
            return next('/login');
        }else{

            store.dispatch('getUserProfile');
        }

    }




    next();
});
